import styles from './Inputs.module.css';

export const BorderRadiusMap = {
    default: styles.defaultBorderRadius,
    small: styles.smallBorderRadius,
    large: styles.largeBorderRadius,
}
